<script>
export default {
  name: "AppInput",

  props: {
    value: [String, Number],
    placeholder: { type: String, default: "" },
    type: { type: String, default: "text" },
    disabled: Boolean,
    dense: Boolean,
    autocomplete: { type: String, default: "off" },
    mask: Object,
  },

  data: () => ({
    focused: false,
  }),

  methods: {
    onInput(e) {
      this.$emit("input", e.target.value);
    },
    onFocus() {
      this.focused = true;
      this.$emit("focus");
    },
    onBlur(e) {
      this.focused = false;
      this.$emit("blur", e);
    },
    focus() {
      this.$refs.input.focus();
    },
  },
};
</script>

<template>
  <div class="app-input" :class="{ 'app-input--focused': focused, 'app-input--disabled': disabled, 'app-input--dense': dense }">
    <input
      ref="input"
      class="app-input__field"
      :type="type"
      :value="value"
      :placeholder="placeholder"
      :disabled="disabled"
      :autocomplete="autocomplete"
      @input="onInput"
      @focus="onFocus"
      @blur="onBlur"
      v-inputmask="mask"
    />
  </div>
</template>

<style lang="scss" scoped>
.app-input {
  display: flex;
  align-items: center;
  min-height: 44px;
  padding: 0 12px;
  border: 1.5px solid #d0d5dd;
  border-radius: 10px;
  background: #fff;
  transition: border-color 0.15s, box-shadow 0.15s;
  cursor: text;
}
.app-input--dense {
  min-height: 40px;
}

.app-input:hover {
  border-color: #98a2b3;
}
.app-input--focused {
  border-color: #00274c;
  box-shadow: 0 0 0 1px #00274c;
}
.app-input--disabled {
  opacity: 0.6;
  pointer-events: none;
}

.app-input__field {
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
  color: #111318;
  line-height: 1.4;
}
.app-input__field::placeholder {
  color: #9ca3af;
}

/* ── Dark mode ── */
.theme--dark .app-input {
  background: #22232e;
  border-color: #2a2c3a;
}
.theme--dark .app-input:hover {
  border-color: #33354a;
}
.theme--dark .app-input--focused {
  border-color: #ffd451;
  box-shadow: 0 0 0 1px #ffd451;
}
.theme--dark .app-input__field {
  color: #d5d6de;
}
.theme--dark .app-input__field::placeholder {
  color: #606275;
}
</style>
